import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export const TagManagerRoot = () => {
  useEffect(() => {
    if (!process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY) return;
    TagManager.initialize({ gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY });
  }, []);

  return <></>;
};
